import {useFind} from '../../../../index'
import {useParams} from '@eitje/bridge'

export const useShow = (kind, {idField = 'id', ...rest} = {}) => {
	const prms = useParams()
	const id = prms[idField]
	return useFind(kind, id, rest)
}

export default useShow
